import {
  DateTimePicker as MantineDateTimePicker,
  DateTimePickerProps,
} from '@mantine/dates';
import {AdapterProps, FieldAdapter} from '../field-factory';
import {FC} from 'react';
import {DateTimeFormats} from '../../components/date';

export type $DateTimePickerAdapterProps = AdapterProps<DateTimePickerProps>;

export const $DateTimePickerAdapter: FC<
  FieldAdapter<$DateTimePickerAdapterProps>
> = ({
  inputProps: {onChange, valueFormat = DateTimeFormats.DateTime, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid}
  } = control;

  const _onChange: $DateTimePickerAdapterProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineDateTimePicker
      error={invalid}
      onChange={_onChange}
      valueFormat={valueFormat}
      {...fieldProps}
      {...inputProps}
    />
  );
};